import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActionSheetController, PopoverController, ToastController } from '@ionic/angular';
import { Router } from "@angular/router";
import { HeaderService } from './header.service';
import { NotificationsComponent } from './notifications/notifications.component';
import { AlertManagementService } from '../pages/alert-management/alert-management.service';
import { DateInterval } from '../model/date-interval.model';
import { version } from '../global.config';
import { DataManagementService } from '../pages/data-management/data-management.service';
import { TranslateService } from '@ngx-translate/core';
import { SigninService } from '../signin/signin.service';
import { User } from '../signin/credentials';
import { RealtimeWorkerService } from '../pages/realtime/realtime-worker.service';
//import { ActionPerformed, PushNotificationSchema, PushNotifications, Token } from '@capacitor/push-notifications';
import { Device } from '@capacitor/device';
import { TokenLutDto } from '../model/data-managemnt';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  // Properties
  searchfield = false;
  charged = false;
  PathArray = [];
  notifications: Notification[] = [];

  dateInterval: DateInterval = new DateInterval();
  currentDate: Date = new Date();
  expirationDatePopup = false;
  daysLeft = 0;
  version: String = version;

  public currentUser: User = new User();
  liveReloadingNotif: any;

  DeviceInfo = '';
  DeviceLang = '';

  tokenLutDto: TokenLutDto = new TokenLutDto();

  // For cleanup
  private destroy$ = new Subject<void>();

  constructor(
    public signinService: SigninService,
    public actionSheetCtrl: ActionSheetController,
    public headerService: HeaderService,
    public popoverCtrl: PopoverController,
    private alertManagementService: AlertManagementService,
    public dataManangementService: DataManagementService,
    private router: Router,
    private realTimeWorker: RealtimeWorkerService,
    public translate: TranslateService,
    private toastController: ToastController
  ) {
    // Load current user
    this.loadCurrentUser();

    // Get device info
    this.initDeviceInfo();
  }

  ngOnInit() {
    // Initialize notification timer
    this.initTimer();

    // Check subscription expiration
    this.checkExpirationDate();

    // Initialize language
    this.initLanguage();

    // Initialize push notifications
   // this.initPushNotifications();
  }

  ngOnDestroy() {
    // Clean up
    this.destroy$.next();
    this.destroy$.complete();

    // Clear notification timer
    if (this.liveReloadingNotif) {
      clearInterval(this.liveReloadingNotif);
    }
  }

  // Load current user from localStorage
  private loadCurrentUser(): void {
    const userString = localStorage.getItem("currentUser");
    if (userString) {
      try {
        this.currentUser = JSON.parse(userString);
      } catch (e) {
        console.error("Error parsing user data:", e);
        this.currentUser = new User();
      }
    }
  }

  // Initialize device information
  private async initDeviceInfo(): Promise<void> {
    try {
      const idInfo = await Device.getId();
      this.DeviceInfo = idInfo.identifier;

      const langInfo = await Device.getLanguageCode();
      this.DeviceLang = langInfo.value;
    } catch (error) {
      console.error("Error getting device info:", error);
    }
  }

  // Initialize language settings
  private initLanguage(): void {
    const storedLang = localStorage.getItem('lang');

    if (!storedLang) {
      // Default to French if no language is set
      this.translate.setDefaultLang('fr');
      this.translate.use('fr');
      localStorage.setItem('lang', 'fr');
    } else {
      // Use stored language
      this.translate.setDefaultLang(storedLang);
      this.translate.use(storedLang);
    }
  }

  // Initialize push notifications
  /*private initPushNotifications(): void {
    // Request permissions
    PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        PushNotifications.register();
      }
    }).catch(err => console.error('Error requesting push notification permissions:', err));

    // Registration success
    PushNotifications.addListener('registration', (token: Token) => {
      console.log(`Push registration success for ${this.DeviceInfo} lang=${this.DeviceLang} token: ${token.value}`);

      this.tokenLutDto = {
        deviceid: this.DeviceInfo,
        username: this.currentUser.username,
        token: token.value,
        language: this.DeviceLang,
        lastTime: new Date()
      };

      this.alertManagementService.add(this.tokenLutDto)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => console.log('Token registered successfully'),
          error: (err) => console.error('Error registering token:', err)
        });
    });

    // Registration error
    PushNotifications.addListener('registrationError', (error: any) => {
      console.error('Error on registration:', JSON.stringify(error));
    });

    // Notification received
    PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
      console.log('Push received:', JSON.stringify(notification));
      // Refresh notifications
      this.loadNotification();
    });

    // Notification action performed
    PushNotifications.addListener('pushNotificationActionPerformed', (notification: ActionPerformed) => {
      console.log('Push action performed:', JSON.stringify(notification));
    });
  }*/

  // Confirm logout
  async logoutconfirm() {
    const lang = localStorage.getItem('lang') || 'fr';
    let actionSheet: HTMLIonActionSheetElement;

    const buttons = [
      {
        text: lang === 'fr' ? 'Annuler' : lang === 'en' ? 'Cancel' : 'إلغاء',
        role: 'cancel',
        handler: () => {}
      },
      {
        text: lang === 'fr' ? 'Déconnexion' : lang === 'en' ? 'Logout' : 'تسجيل الخروج',
        cssClass: 'Logout',
        handler: () => {
          this.logout();
        }
      }
    ];

    actionSheet = await this.actionSheetCtrl.create({
      header: lang === 'fr' ? 'Souhaitez-vous vraiment vous déconnecter?' :
        lang === 'en' ? 'Are you sure you want to log out?' :
          'هل أنت متأكد أنك تريد تسجيل الخروج؟',
      buttons
    });

    await actionSheet.present();
  }

  // Perform logout
  logout() {
    // Clear local data
    this.dataManangementService.pointInterests = [];
    this.dataManangementService.selectedGroup = null;
    this.dataManangementService.selectedVehicule = null;
    this.dataManangementService.groups = [];
    this.notifications = [];

    // Clear localStorage
    localStorage.removeItem("id_token");
    localStorage.removeItem("currentUser");
    localStorage.removeItem("groups");
    localStorage.removeItem("pointInterests");

    // Set auth state to false
    this.signinService.authState = false;

    // Navigate to signin
    this.router.navigate(['signin']);

    // Clear notification timer
    clearInterval(this.liveReloadingNotif);
  }

  // Show notifications popover
  async clickNotifications(ev: any) {
    const popover = await this.popoverCtrl.create({
      component: NotificationsComponent,
      event: ev,
      animated: true,
      showBackdrop: true,
      cssClass: 'notifPopover',
      componentProps: { notifications: this.notifications }
    });

    return await popover.present();
  }

  // Load notifications
  loadNotification() {
    this.alertManagementService
      .getNotifications(this.dateInterval)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (notifications) => {
          this.notifications = notifications;
        },
        error: (err) => console.error('Error loading notifications:', err)
      });
  }

  // Initialize notification timer
  initTimer() {
    // Clear any existing timer
    if (this.liveReloadingNotif) {
      clearInterval(this.liveReloadingNotif);
    }

    // Load notifications immediately
    this.loadNotification();

    // Set up timer for regular refresh
    this.liveReloadingNotif = setInterval(() => {
      this.loadNotification();
    }, 20000); // Every 20 seconds
  }

  // Check subscription expiration date
  checkExpirationDate() {
    if (this.currentUser && this.currentUser.expirationDate && this.currentUser.isRoot) {
      const userExpirationDate = new Date(this.currentUser.expirationDate);
      this.daysLeft = Math.round((userExpirationDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));

      if (this.daysLeft <= 15) {
        this.expirationDatePopup = true;
      }
    }
  }

  // Clean history
  cleanHistory() {
    const groups = this.realTimeWorker.dataManagementService.groups;

    if (groups && groups.length > 0) {
      const firstGroup = groups[0];

      // Reset selection to first group
      this.realTimeWorker.dataManagementService.selectedGroup = firstGroup;

      // If group has vehicles, select the first one
      if (firstGroup.vehicules && firstGroup.vehicules.length > 0) {
        this.realTimeWorker.dataManagementService.selectedVehicule = firstGroup.vehicules[0];
      }
    }
  }

  // Switch language
  switchLanguage(lang: string) {
    // Set language in translator
    this.translate.use(lang);

    // Store language preference
    localStorage.setItem('lang', lang);

    // Show confirmation message
    let message = '';
    switch (lang) {
      case 'fr':
        message = 'Langue Français sélectionnée';
        break;
      case 'en':
        message = 'Language English selected';
        break;
      case 'ar':
        message = 'اللغة العربية المختارة';
        break;
    }

    this.showLanguageConfirmation(message);
  }

  // Show language selection confirmation
  async showLanguageConfirmation(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 2000,
      position: 'top',
      cssClass: 'language-toast'
    });

    toast.present();
  }

  // Show language selection action sheet
  async chooseLanguge() {
    const currentLang = this.translate.currentLang || this.translate.defaultLang;
    let actionSheet: HTMLIonActionSheetElement;

    const buttons = [
      {
        text: currentLang === 'fr' ? 'Annuler' : currentLang === 'en' ? 'Cancel' : 'إلغاء',
        role: 'cancel',
        handler: () => {}
      },
      {
        text: currentLang === 'fr' ? 'Anglais' : currentLang === 'en' ? 'English' : 'الإنجليزية',
        handler: () => {
          this.switchLanguage('en');
        }
      },
      {
        text: currentLang === 'fr' ? 'Français' : currentLang === 'en' ? 'French' : 'الفرنسية',
        handler: () => {
          this.switchLanguage('fr');
        }
      },
      {
        text: currentLang === 'fr' ? 'Arabe' : currentLang === 'en' ? 'Arabic' : 'العربية',
        handler: () => {
          this.switchLanguage('ar');
        }
      }
    ];

    actionSheet = await this.actionSheetCtrl.create({
      header: currentLang === 'fr' ? 'Sélectionner une langue' : 'Select Language',
      buttons
    });

    await actionSheet.present();
  }

  // Check if cam option is available
  isHasCamOption() {
    return this.signinService.isHasCamOption();
  }
}
